module.exports = __webpack_public_path__ + "img/7.2a09713f.jpg";